// deps
import React, { useMemo, memo } from "react";

// helpers
import { OriginalValue } from "./styles";
import { getDiscountedValue } from "../../helpers/giftcard";

// styles

interface ButtonChildProps {
    amount: string;
    discount?: number;
    minimumDiscountValue?: number;
    showError?: boolean;
}

const ButtonChild = ({ amount, discount, minimumDiscountValue, showError }: ButtonChildProps) => {
    const getAmountString = useMemo(() => {
        if (amount !== getDiscountedValue(amount, discount, minimumDiscountValue)) {
            return (
                <>
                    <OriginalValue>₹{amount}</OriginalValue> ₹
                    {getDiscountedValue(amount, discount, minimumDiscountValue)}
                </>
            );
        } else {
            return <>₹{amount}</>;
        }
    }, [amount, discount, minimumDiscountValue]);

    return <>Proceed to pay {!showError ? amount && getAmountString : ""}</>;
};

export default memo(ButtonChild);
